/**
 * vd-reveal.js — lightweight scroll-reveal for `.vd-reveal` elements.
 *
 * Content is visible by default (see velodream.css) and only becomes
 * hidden once this script confirms it is running, by adding
 * `vd-reveal-js` to <html>. That way, if this script never loads or
 * errors, nothing is ever hidden — the CSS gate requires the class this
 * script adds, not the reverse.
 */

/**
 * Measures the combined flow height of the announcement bar + header
 * section group — both are wrapped individually by Shopify's
 * `{% sections 'header-group' %}` tag with the shared class
 * `.shopify-section-group-header-group` (see theme.liquid) — and writes
 * it to `--vd-header-stack` on <html>.
 *
 * .vd-hero (velodream.css) subtracts this from `100dvh` because the
 * header stack renders ABOVE the hero in normal document flow (the
 * sticky header in header.liquid still occupies its flow height even
 * when transparent/overlaying, since `position: sticky` never removes
 * an element from flow). Without subtracting it, a `100dvh` hero with
 * bottom-anchored content gets pushed below the fold by exactly the
 * header stack's height on short viewports.
 *
 * Defaults to 0px (current/no-JS behavior) if the selector is missing
 * or this script never runs — see the `560px` / `100dvh` fallback
 * chain on `.vd-hero` in velodream.css.
 */
function updateHeaderStackHeight() {
  var stackEls = document.querySelectorAll('.shopify-section-group-header-group');
  var stackHeight = 0;

  stackEls.forEach(function (el) {
    stackHeight += el.offsetHeight;
  });

  document.documentElement.style.setProperty('--vd-header-stack', stackHeight + 'px');
}

document.addEventListener('DOMContentLoaded', function () {
  updateHeaderStackHeight();

  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    var currentWidth = window.innerWidth;
    // Ignore height-only resizes (e.g. mobile browser chrome
    // showing/hiding on scroll) — only width changes can change the
    // header stack's wrapped height.
    if (currentWidth === lastWidth) return;
    lastWidth = currentWidth;
    updateHeaderStackHeight();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.classList.add('vd-reveal-js');

  var targets = document.querySelectorAll('.vd-reveal');
  if (!targets.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || typeof IntersectionObserver === 'undefined') {
    targets.forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
});
